import { featuresData } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台特色</h2>
          <p className="text-sm text-foreground-500 mt-2">为什么数百万用户选择吃瓜官网</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuresData.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col items-center text-center group hover:bg-background-50 transition-colors">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-2xl mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}